import type { Job } from "../../../../../../../models";
import type { JobCardInfo } from "./types";
import { parseDraggableId } from "./draggableId.helpers";

export function getJobGrowerName(job: Job): string {
	return job.importGrowerName || job.growerName || "";
}

export function getJobCardInfo(job: Job): JobCardInfo {
	return {
		jobId: job.id,
		growerName: getJobGrowerName(job),
		farmName: job.importFarmName || job.farmName || "",
		fieldName: job.importFieldName || job.fieldName || "",
	};
}

export function groupJobsByGrower(jobs: Job[]): Map<string, JobCardInfo[]> {
	const map = new Map<string, JobCardInfo[]>();
	for (const job of jobs) {
		const growerName = getJobGrowerName(job);
		if (!growerName) continue;
		const info = getJobCardInfo(job);
		const existing = map.get(growerName);
		if (existing) {
			existing.push(info);
		} else {
			map.set(growerName, [info]);
		}
	}
	return map;
}

export function countUnassignedJobs(jobs: Job[], assignments: Record<string, string>): number {
	return jobs.filter((job) => !assignments[job.id]).length;
}

export function expandSelectionToJobIds(selected: Set<string>, jobsByGrower: Map<string, JobCardInfo[]>): string[] {
	const jobIds: string[] = [];
	for (const id of selected) {
		const parsed = parseDraggableId(id);
		if (parsed.type === "grower") {
			const jobs = jobsByGrower.get(parsed.key) || [];
			for (const job of jobs) {
				jobIds.push(job.jobId);
			}
		} else {
			jobIds.push(parsed.key);
		}
	}
	return jobIds;
}
